import { schedulingApi } from "./scheduling.api";

export const {
  useSaveSchedulingCloseMutation,
  useSaveSchedulingMutation,
  useGetSchedulingsByDriverQuery,
  useLazyGetSchedulingsByDriverQuery,
  useListSchedulingDeletedByDriverInfiniteQuery
} = schedulingApi;
